import TransferDetailsPage from './TransferDetailsPage';

export default TransferDetailsPage;
